// Single source of truth for the win-probability band colour.
//
// The sidebar gauge and the next-step card both colour a score, and two copies
// of the thresholds would drift apart: the same number would read "strong" in
// one block and "weak" in the other. The bands are intentionally coarse —
// 70+ is a healthy deal, 40+ is worth working, below 40 is at risk.

export type ScoreTone = 'success' | 'primary' | 'error';

export function scoreTone(score: number): ScoreTone {
  if (score >= 70) return 'success';
  if (score >= 40) return 'primary';
  return 'error';
}

/** AntD design-token colour of a score band (CSS custom property). */
export function scoreToneColor(score: number): string {
  return `var(--ant-color-${scoreTone(score)})`;
}
